const setTokenAuth = (state, token) => state.auth_token = token;
const setUser = (state, user) => state.user = user;

let mutations = {
  setTokenAuth,
  setUser,
};

export default mutations;
